/* tslint:disable */
/* eslint-disable */
/**
 * Xpanse Portal BFF Service API
 * Rest API for Xpanse Portal
 *
 * The version of the OpenAPI document: @project.version@
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WhiteLabelingSettings
 */
export interface WhiteLabelingSettings {
    /**
     * 
     * @type {string}
     * @memberof WhiteLabelingSettings
     */
    theme: WhiteLabelingSettingsThemeEnum;
    /**
     * 
     * @type {string}
     * @memberof WhiteLabelingSettings
     */
    preset: string;
    /**
     * 
     * @type {string}
     * @memberof WhiteLabelingSettings
     */
    primaryColor: string;
    /**
     * 
     * @type {string}
     * @memberof WhiteLabelingSettings
     */
    logo: string;
}


/**
 * @export
 */
export const WhiteLabelingSettingsThemeEnum = {
    Light: 'Light',
    Dark: 'Dark'
} as const;
export type WhiteLabelingSettingsThemeEnum = typeof WhiteLabelingSettingsThemeEnum[keyof typeof WhiteLabelingSettingsThemeEnum];


/**
 * Check if a given object implements the WhiteLabelingSettings interface.
 */
export function instanceOfWhiteLabelingSettings(value: object): value is WhiteLabelingSettings {
    if (!('theme' in value) || value['theme'] === undefined) return false;
    if (!('preset' in value) || value['preset'] === undefined) return false;
    if (!('primaryColor' in value) || value['primaryColor'] === undefined) return false;
    if (!('logo' in value) || value['logo'] === undefined) return false;
    return true;
}

export function WhiteLabelingSettingsFromJSON(json: any): WhiteLabelingSettings {
    return WhiteLabelingSettingsFromJSONTyped(json, false);
}

export function WhiteLabelingSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): WhiteLabelingSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'theme': json['theme'],
        'preset': json['preset'],
        'primaryColor': json['primaryColor'],
        'logo': json['logo'],
    };
}

export function WhiteLabelingSettingsToJSON(json: any): WhiteLabelingSettings {
    return WhiteLabelingSettingsToJSONTyped(json, false);
}

export function WhiteLabelingSettingsToJSONTyped(value?: WhiteLabelingSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'theme': value['theme'],
        'preset': value['preset'],
        'primaryColor': value['primaryColor'],
        'logo': value['logo'],
    };
}

